import SecInfoHistorico from "../Gestao/SecInfoHistorico";

export default SecInfoHistorico;